export default __webpack_public_path__ + "static/media/shoulder_press_end.67fbf9ea.svg";